__turbopack_context__.v({
  "chart": "ScoreTimeline-module__Xcn8OW__chart",
  "chartCompact": "ScoreTimeline-module__Xcn8OW__chartCompact",
  "scoreDot": "ScoreTimeline-module__Xcn8OW__scoreDot",
  "scoreGradient": "ScoreTimeline-module__Xcn8OW__scoreGradient",
  "scoreLine": "ScoreTimeline-module__Xcn8OW__scoreLine",
});
